export default function NotFound() {
    return (
        <div>
            <h2>Page Not found</h2>
        </div>
    )
}
